/*
* @Author: ssxu9
* @Date:   2016-04-04 21:31:30
* @Last Modified by:   ssxu9
* @Last Modified time: 2016-04-09 21:04:06
*/
import {
    SET_USER_ID,
    SET_USER_NAME,
    SET_TASK_ID,
    SET_COMPLETE_ANS,
    SET_BASE_INFO,
    SET_PROCESS_ID,
    SET_NEXT_PROCESS_ID,
    SET_NODE_INFO,
    SET_USER_LIST,
    SET_CHECKED_USER,
    SET_COUNT
} from '../mutation-types'

const state = {
    userId: '',
    userName: '',
    taskId: '', // 单据号
    processId: '', // taskId流程号
    nextProcessId: '',
    completeAns: false, // 是否有案卷管理的权限
    baseInfo: '',
    nodeInfo: '',
    checkedUser: [],
    userList: [],
    count: 0
}

const mutations = {
    [SET_USER_ID] (state, newUserId) {
        state.userId = newUserId
    },
    [SET_USER_NAME] (state, newUserName) {
        state.userName = newUserName
    },
    [SET_TASK_ID] (state, newTaskId) {
        state.taskId = newTaskId
    },
    [SET_COMPLETE_ANS] (state, nowStatus) {
        state.completeAns = nowStatus
    },
    [SET_BASE_INFO] (state, nowBaseInfo) {
        state.baseInfo = nowBaseInfo
    },
    [SET_PROCESS_ID] (state, nowProcessId) {
        state.processId = nowProcessId
    },
    [SET_NEXT_PROCESS_ID] (state, nowNextProcessId) {
        state.nextProcessId = nowNextProcessId
    },
    [SET_NODE_INFO] (state, nowNodeInfo) {
        state.nodeInfo = nowNodeInfo
    },
    [SET_USER_LIST] (state, nowUserList) {
        state.userList = nowUserList
    },
    [SET_CHECKED_USER] (state, nowCheckedUser) {
        state.checkedUser = nowCheckedUser
    },
    [SET_COUNT] (state, nowCount) {
        state.count = nowCount
    }
}

export default {
    state,
    mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/user.js